import React from 'react'
import Traduction from 'Components/Traduction'
import Input from 'Components/Input'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import TimePicker from 'Components/TimePicker'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'
import Title from 'Components/Title'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor(props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount() {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getService()
    }
  }

  getService = async () => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'service',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        produit_id: result.results.produit_id,
        intervalle: result.results.intervalle,
        ordre: result.results.ordre,
        heure_debut: result.results.heure_debut,
        heure_fin: result.results.heure_fin,
        duree_limite_fermeture: result.results.duree_limite_fermeture,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      intervalle: undefined,
      ordre: undefined,
      heure_debut: undefined,
      heure_fin: undefined,
      duree_limite_fermeture: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'service',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      intervalle: this.state.intervalle,
      produit_id: this.state.produit_id,
      ordre: this.state.ordre,
      heure_debut: this.state.heure_debut,
      heure_fin: this.state.heure_fin,
      duree_limite_fermeture: this.state.duree_limite_fermeture,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'restaurant', {
      requete: 'service',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
        justify="flex-start"
        alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'libelle'}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Input
          title={EurestoI18n.t('commun:Ordre')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'ordre'}
          value={this.state.ordre !== undefined ? this.state.ordre : ''}
          type={'number'} />

        <Input
          title={EurestoI18n.t('commun:Intervalle')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'intervalle'}
          value={this.state.intervalle !== undefined ? this.state.intervalle : ''}
          type={'number'} />
        <Title
          title={EurestoI18n.t('commun:Durée limite de prise de réservation avant début du service')}>
          <Input
            disabled={disabled}
            onChange={this.onChangeState}
            name={'duree_limite_fermeture'}
            value={this.state.duree_limite_fermeture !== undefined ? this.state.duree_limite_fermeture : ''}
            type={'number'} />
        </Title>
        <Grid item style={{ margin: 0, padding: 0 }}>
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction={'row'} justify={'center'}
            alignItems={'center'}>
            <Grid item xs={6} style={{ margin: 0, padding: '0 5px' }}>
              <TimePicker
                title={EurestoI18n.t('commun:Heure de début')}
                disabled={disabled}
                onChange={this.onChangeState}
                name={'heure_debut'}
                value={this.state.heure_debut !== undefined ? this.state.heure_debut : ''} />
            </Grid>
            <Grid item xs={6} style={{ margin: 0, padding: '0 5px' }}>
              <TimePicker
                title={EurestoI18n.t('commun:Heure de fin')}
                disabled={disabled}
                onChange={this.onChangeState}
                name={'heure_fin'}
                value={this.state.heure_fin !== undefined ? this.state.heure_fin : ''} />
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    )
  }

  render() {
    return (
      <EurestoForm key={this.state.key}
        {...this.props.formProps}
        libelle={this.state.defaultLibelle}
        action={this.state.action}
        isAllow={this.props.isAllow}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onDelete={this.onDelete}
        onArchive={this.onArchive}
        onView={this.onView}
        libelleAdd={EurestoI18n.t('commun:Nouveau service')}
        children={this.form} />
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Reservation/Service.js